export default __webpack_public_path__ + "static/media/dimgr-hover.befcf783.svg";